import { crud } from '@think-internet/zeus-frontend-package'

const props = {
  ...crud.Features,
}

export default props
